import {
    Table,
    Typography,
    Tooltip,
    Button,
    Space,
    TimePicker,
    Select,
    Spin,
    Empty,
    message,
    Form,
} from 'antd';
import {
    EditOutlined,
    SaveOutlined,
    CloseOutlined,
    CheckOutlined,
    DeleteOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { taskList, tasksState } from '../../modules/tasks/tasks.slice';
import { IconReset } from '../../assets/icons/resetIcon';
import { BinIcon } from '../../assets/icons';
import { IconClockTime } from '../../assets/icons/timeIcon';

const { Text } = Typography;

const WorkReportFlatTable = ({ tableBody = [], editedTimeLogs, setEditedTimeLogs, setTaskErrors, taskErrors }) => {
    const [editingRowId, setEditingRowId] = useState(null);
    const [editedTimes, setEditedTimes] = useState({});
    const dispatch = useDispatch()
    const pdfDataInRedux = useSelector((state) => state.reportTimesheet)
    const projectData = pdfDataInRedux?.pdfSelectedData
    const updateEditedTimeLogs = (record, newDuration) => {
        const updatedTableBody = editedTimeLogs?.tableBody?.map((userData) => {
            if (userData._id?.assigneeId !== record.assigneeId) return userData;

            return {
                ...userData,
                list: userData.list.map((logByDate) => {
                    if (logByDate._id?.startLogDate !== record.startLogDate) return logByDate;

                    let updatedTasks = logByDate.list.map((task) => {
                        if (task.timelogs?._id === record.timelogs._id) {
                            return {
                                ...task,
                                taskTotalLog: newDuration, // only update matched task
                            };
                        }
                        return task; // leave other tasks untouched
                    });

                    // Set totalLog = taskTotalLog of matched task only
                    const matchedTask = updatedTasks.find(
                        (task) => task.timelogs?._id === record.timelogs._id
                    );

                    return {
                        ...logByDate,
                        list: updatedTasks,
                        totalLog: matchedTask ? matchedTask.taskTotalLog : logByDate.totalLog,
                    };
                }),
            };
        });

        setEditedTimeLogs({
            ...editedTimeLogs,
            tableBody: updatedTableBody,
        });
    };

    const getRemainingTime = (record) => {
        const MAX_MS = 24 * 3600 * 1000; // 24 hours in ms

        // find the user
        const user = editedTimeLogs?.tableBody?.find(u => u._id?.assigneeId === record.assigneeId);
        if (!user) return { hours: 24, minutes: 0, seconds: 0, remainingMs: MAX_MS };

        // get all tasks for the same day
        const dateLogs = user.list?.filter(d => d._id?.startLogDate === record.startLogDate);
        if (!dateLogs?.length) return { hours: 24, minutes: 0, seconds: 0, remainingMs: MAX_MS };

        // Sum totalLog of all tasks **except the current task**
        let usedMs = 0;
        dateLogs.forEach(dateLog => {
            dateLog.list?.forEach(task => {
                if (task.timelogs?._id !== record.timelogs._id) {
                    usedMs += dateLog.totalLog || 0;
                }
            });
        });

        // remaining time
        const remainingMs = Math.max(MAX_MS - usedMs, 0);

        const hours = Math.floor(remainingMs / (3600 * 1000));
        const minutes = Math.floor((remainingMs % (3600 * 1000)) / (60 * 1000));
        const seconds = Math.floor((remainingMs % (60 * 1000)) / 1000);

        return { hours, minutes, seconds, remainingMs };
    };




    const {
        tasks,
        formModal,
        skipPage,
        pageLimit,
        status,
        filterDropDown: taskFilterDropdown,
        search,
    } = useSelector(tasksState)

    // const groupedTaskOptions = tasks?.map((group) => ({
    //     label: group._id,
    //     options: group.list.map((task) => ({
    //         label: task.title,
    //         value: task.title,
    //         key: task._id,
    //     })),
    // }));

    const groupedTaskOptions = useMemo(() => {
        if (!tasks) return [];
        return tasks
            ?.filter((group) => group.list && group.list.length > 0)
            .map((group) => ({
                label: group?._id, // e.g. "To Do"
                options: [
                    ...new Map(
                        group?.list.map((task) => [
                            task?._id,
                            {
                                label: `${task?.taskKey} - ${task?.title}`,
                                value: task?.title,
                            },
                        ])
                    ).values(),
                ],
            }));
    }, [tasks])


    const getTasksList = (userId, projectId) => {
        try {

            dispatch(
                taskList({
                    skip: 0,
                    limit: 100,
                    filter: {
                        projectId: projectId,
                        assignee: [userId],
                        taskType: "Task",
                        isReport: true

                    },
                })
            )
        } catch (error) {
            console.log("🚀 ~ getTasksList ~ error:", error)

        }
    }
    // const handleDeleteManualTask = (assigneeId, startLogDate, timelogId) => {
    //     const updatedTableBody = editedTimeLogs?.tableBody?.map((userData) => {
    //         if (userData._id?.assigneeId !== assigneeId) return userData;

    //         return {
    //             ...userData,
    //             list: userData.list.map((logByDate) => {
    //                 if (logByDate._id?.startLogDate !== startLogDate) return logByDate;

    //                 // Remove the task
    //                 const updatedTasks = logByDate.list.filter(
    //                     (task) => task.timelogs._id !== timelogId
    //                 );

    //                 // Sum totalLog from remaining tasks
    //                 const totalLog = logByDate.totalLog

    //                 return {
    //                     ...logByDate,
    //                     list: updatedTasks,
    //                     totalLog,
    //                 };
    //             })
    //         };
    //     })

    //     setEditedTimeLogs({
    //         ...editedTimeLogs,
    //         tableBody: updatedTableBody,
    //     });
    // };


    const handleDeleteManualTask = (assigneeId, startLogDate, timelogId) => {
        const updatedTableBody = editedTimeLogs?.tableBody?.map((userData) => {
            if (userData._id?.assigneeId !== assigneeId) return userData;

            return {
                ...userData,
                // ✅ remove pura logByDate object je timelogId sathe match thay
                list: userData.list.filter((logByDate) => {
                    if (logByDate._id?.startLogDate !== startLogDate) return true;

                    // check inside logByDate.list for timelog match
                    const hasMatch = logByDate.list.some((task) => {
                        const taskTimeLogId = task?.timelogs?._id || task?._id;
                        return taskTimeLogId === timelogId;
                    });

                    // ❌ if match → remove entire logByDate
                    return !hasMatch;
                }),
            };
        });

        setEditedTimeLogs({
            ...editedTimeLogs,
            tableBody: updatedTableBody,
        });
    };



    const safeArray = Array.isArray(tableBody) ? tableBody : [tableBody]

    const flatData = safeArray.flatMap((row) =>
        (row?.list || []).map((task) => ({
            ...task,
            startLogDate: row._id?.startLogDate,
            assigneeId: row._id?.assigneeId,

        }))
    )
    const hasManualTasks = flatData.some((row) => row.addManualTask);

    const columns = [
        {
            title: 'Task',
            dataIndex: 'title',
            key: 'title',
            width: 250,
            ellipsis: { showTitle: false },
            render: (_, record) => {
                if (!record?.title) {
                    return (
                        <Form.Item
                            validateStatus={
                                taskErrors?.[record._id] ? "error" : ""
                            }
                            help={taskErrors?.[record._id] || ""}
                            style={{ marginBottom: 0, whiteSpace: "normal" }}
                        >

                            <Select
                                autoFocus
                                showSearch
                                style={{ width: '100%' }}
                                className='select_input_height'
                                placeholder="Select Task"
                                onDropdownVisibleChange={(open) => {
                                    if (open) {
                                        getTasksList(record.assigneeId, projectData?.project?.id);
                                    }
                                }}
                                notFoundContent={
                                    status === 'loading' ? <Spin size="small" /> : <Empty />
                                }
                                filterOption={(input, option) =>
                                    option?.label?.toLowerCase().includes(input.toLowerCase())
                                }
                                onChange={(value) => {
                                    // 🔍 check duplicate task in same assignee + same date
                                    const alreadyExists = editedTimeLogs?.tableBody?.some((userData) => {
                                        if (userData._id?.assigneeId !== record.assigneeId) return false;

                                        return userData.list.some((logByDate) => {
                                            if (logByDate._id?.startLogDate !== record.startLogDate) return false;

                                            return logByDate.list.some(
                                                (task) =>
                                                    task.title?.toLowerCase().trim() === value.toLowerCase().trim() &&
                                                    task.timelogs._id !== record.timelogs._id // skip current row
                                            );
                                        });
                                    });

                                    if (alreadyExists) {
                                        // message.warning("This task is already added for this date");
                                        setTaskErrors((prev) => ({
                                            ...prev,
                                            [record._id]: "This task is already added for this date",
                                        }));
                                        return;
                                    }

                                    // ✅ Update task title
                                    const updatedTableBody = editedTimeLogs?.tableBody?.map((userData) => {
                                        if (userData._id?.assigneeId !== record.assigneeId) return userData;

                                        return {
                                            ...userData,
                                            list: userData.list.map((logByDate) => {
                                                if (logByDate._id?.startLogDate !== record.startLogDate) return logByDate;

                                                const updatedTasks = logByDate.list.map((task) => {
                                                    if (task.timelogs._id === record.timelogs._id) {
                                                        return {
                                                            ...task,
                                                            title: value,
                                                        };
                                                    }
                                                    return task;
                                                });

                                                return {
                                                    ...logByDate,
                                                    list: updatedTasks,
                                                };
                                            }),
                                        };
                                    });

                                    setEditedTimeLogs({
                                        ...editedTimeLogs,
                                        tableBody: updatedTableBody,
                                    });
                                }}
                                // onChange={(value) => {
                                //     const updatedTableBody = editedTimeLogs?.tableBody?.map((userData) => {
                                //         if (userData._id?.assigneeId !== record.assigneeId) return userData;

                                //         return {
                                //             ...userData,
                                //             list: userData.list.map((logByDate) => {
                                //                 if (logByDate._id?.startLogDate !== record.startLogDate) return logByDate;

                                //                 const updatedTasks = logByDate.list.map((task) => {
                                //                     if (task.timelogs._id === record.timelogs._id) {
                                //                         return {
                                //                             ...task,
                                //                             title: value,
                                //                         };
                                //                     }
                                //                     return task;
                                //                 });

                                //                 return {
                                //                     ...logByDate,
                                //                     list: updatedTasks,
                                //                 };
                                //             }),
                                //         };
                                //     });

                                //     setEditedTimeLogs({
                                //         ...editedTimeLogs,
                                //         tableBody: updatedTableBody,
                                //     });
                                // }}
                                // ✅ while loading, don’t pass options
                                options={status === 'loading' ? [] : groupedTaskOptions}
                            />
                        </Form.Item>


                    );
                }

                return (
                    <Tooltip title={record.title}>
                        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {record.title}
                        </div>
                    </Tooltip>
                );
            },

        },
        {
            title: 'Estimation',
            dataIndex: 'estimation',
            key: 'estimation',
            width: 150,
            render: (text) => (text ? `${text} min` : '0'),
        },
        {
            title: 'Date',
            dataIndex: 'startLogDate',
            key: 'startLogDate',
            width: 150,
            render: (text) => (text ? dayjs(text).format('DD MMM YYYY') : ''),
        },
        {
            title: 'Time Logged',
            dataIndex: 'taskTotalLog',
            key: 'taskTotalLog',
            // render: (_, record) => {
            //     const isEditing = editingRowId === record.timelogs._id;
            //     const { start, end } = record?.timelogs
            //     const picked = editedTimes[record.timelogs._id];

            //     const duration = record.taskTotalLog || 0;
            //     const h = Math.floor(duration / 3600000);
            //     const m = Math.floor((duration % 3600000) / 60000);
            //     const s = Math.floor((duration % 60000) / 1000);
            //     const timeStr = `${h}h ${m}m ${s}s`;

            //     return isEditing ? (
            //         <Space>
            //             <TimePicker
            //                 value={picked}
            //                 onChange={(val) => {
            //                     setEditedTimes((prev) => ({
            //                         ...prev,
            //                         [record.timelogs._id]: val,
            //                     }));
            //                 }}
            //                 format="HH:mm:ss"
            //                 allowClear={false}
            //             />
            //             <Tooltip title="Save">
            //                 <Button
            //                     icon={<CheckOutlined style={{ color: "green" }} />}
            //                     type="primary"
            //                     size="small"
            //                     style={{ backgroundColor: "transparent", border: "none" }}
            //                     onClick={() => {
            //                         if (!picked) return;
            //                         const newDuration =
            //                             (picked.hour() * 3600 +
            //                                 picked.minute() * 60 +
            //                                 picked.second()) *
            //                             1000;

            //                         updateEditedTimeLogs(record, newDuration);
            //                         setEditingRowId(null);
            //                     }}
            //                 />
            //             </Tooltip>
            //             <Tooltip title="Cancel">
            //                 <Button
            //                     icon={<CloseOutlined style={{ color: "red", fontSize: "15px" }} />}
            //                     size="small"

            //                     style={{ backgroundColor: "transparent", border: "none" }}
            //                     onClick={() => {
            //                         setEditingRowId(null);
            //                         setEditedTimes((prev) => {
            //                             const { [record.timelogs._id]: _, ...rest } = prev;
            //                             return rest;
            //                         });
            //                     }}
            //                 />
            //             </Tooltip>
            //         </Space>
            //     ) : (
            //         <Space>
            //             <Text>{timeStr}</Text>
            //             <Tooltip title="Edit">
            //                 <Button
            //                     type="text"
            //                     icon={<EditOutlined style={{ color: "#000" }} />}
            //                     size="small"
            //                     onClick={() => {
            //                         const totalMs = record.taskTotalLog || 0;
            //                         const h = Math.floor(totalMs / 3600000);
            //                         const m = Math.floor((totalMs % 3600000) / 60000);
            //                         const s = Math.floor((totalMs % 60000) / 1000);

            //                         setEditingRowId(record.timelogs._id);
            //                         setEditedTimes((prev) => ({
            //                             ...prev,
            //                             [record.timelogs._id]: dayjs()
            //                                 .hour(h)
            //                                 .minute(m)
            //                                 .second(s),
            //                         }));
            //                     }}
            //                 />
            //             </Tooltip>
            //         </Space>
            //     );
            // },
            render: (_, record) => {
                const isEditing = editingRowId === record.timelogs._id;
                const { start, end } = record?.timelogs || {};
                const picked = editedTimes[record.timelogs._id];

                const duration = record.taskTotalLog || 0;
                const h = Math.floor(duration / 3600000);
                const m = Math.floor((duration % 3600000) / 60000);
                const s = Math.floor((duration % 60000) / 1000);
                const timeStr = `${h}h ${m}m ${s}s`;

                if (isEditing) {
                    return (
                        <Space>
                            <TimePicker
                                popupClassName="custom-timepicker-popup"
                                showNow={false}
                                suffixIcon={<IconClockTime width={23} style={{ backgroundColor: "white", color: "#5d5d5dff" }} />}
                                value={picked}
                                onChange={(val) => setEditedTimes(prev => ({ ...prev, [record.timelogs._id]: val }))}
                                format="HH:mm:ss"
                                allowClear={false}
                                disabledHours={() => {
                                    const { hours, remainingMs } = getRemainingTime(record);
                                    if (remainingMs <= 0) return Array.from({ length: 24 }, (_, i) => i); // disable all
                                    return Array.from({ length: 24 }, (_, i) => i).filter(i => i > hours);
                                }}
                                disabledMinutes={(selectedHour) => {
                                    const { hours, minutes, remainingMs } = getRemainingTime(record);
                                    if (remainingMs <= 0) return Array.from({ length: 60 }, (_, i) => i); // disable all
                                    return selectedHour === hours
                                        ? Array.from({ length: 60 }, (_, i) => i).filter(i => i > minutes)
                                        : [];
                                }}
                                disabledSeconds={(selectedHour, selectedMinute) => {
                                    const { hours, minutes, seconds, remainingMs } = getRemainingTime(record);
                                    if (remainingMs <= 0) return Array.from({ length: 60 }, (_, i) => i); // disable all
                                    return selectedHour === hours && selectedMinute === minutes
                                        ? Array.from({ length: 60 }, (_, i) => i).filter(i => i > seconds)
                                        : [];
                                }}
                            />
                            <Tooltip title="Save">
                                <Button
                                    icon={<CheckOutlined style={{ color: "green" }} />}
                                    type="primary"
                                    size="small"
                                    style={{ backgroundColor: "transparent", border: "none" }}
                                    onClick={() => {
                                        if (!picked) return;
                                        const newDuration =
                                            (picked.hour() * 3600 +
                                                picked.minute() * 60 +
                                                picked.second()) *
                                            1000;

                                        updateEditedTimeLogs(record, newDuration);
                                        setEditingRowId(null);
                                    }}
                                />
                            </Tooltip>
                            <Tooltip title="Cancel">
                                <Button
                                    icon={<CloseOutlined style={{ color: "red", fontSize: "15px" }} />}
                                    size="small"
                                    style={{ backgroundColor: "transparent", border: "none" }}
                                    onClick={() => {
                                        setEditingRowId(null);
                                        setEditedTimes((prev) => {
                                            const { [record.timelogs._id]: _, ...rest } = prev;
                                            return rest;
                                        });
                                    }}
                                />
                            </Tooltip>
                        </Space>
                    );
                }

                return (
                    <Space>
                        <Text>{timeStr}</Text>
                        <Tooltip title="Edit">
                            <Button
                                type="text"
                                icon={<EditOutlined style={{ color: "#000" }} />}
                                size="small"
                                onClick={() => {
                                    if (!record?.title) {

                                        message.warning("Please select a task first");
                                        return;
                                    }
                                    const totalMs = record.taskTotalLog || 0;
                                    const h = Math.floor(totalMs / 3600000);
                                    const m = Math.floor((totalMs % 3600000) / 60000);
                                    const s = Math.floor((totalMs % 60000) / 1000);

                                    setEditingRowId(record.timelogs._id);
                                    setEditedTimes((prev) => ({
                                        ...prev,
                                        [record.timelogs._id]: dayjs()
                                            .hour(h)
                                            .minute(m)
                                            .second(s),
                                    }));
                                }}
                            />
                        </Tooltip>
                        <Tooltip title="Reset Time">
                            <Button
                                type="text"
                                icon={<IconReset style={{ color: "#000" }} width={20} />} // you can change icon if you want
                                size="small"
                                onClick={() => {
                                    updateEditedTimeLogs(record, 0); // reset duration to 0
                                }}
                            />
                        </Tooltip>
                    </Space>
                );
            }
        },


    ];

    if (hasManualTasks) {
        columns.push({
            title: "Action",
            key: "action",
            width: 80,
            render: (_, record) => {
                if (!record.addManualTask) return null;

                return (
                    <Tooltip title="Delete Task">
                        <Button
                            type="text"
                            icon={<DeleteOutlined style={{ color: "#ff4d4f" }} />}
                            onClick={() =>
                                handleDeleteManualTask(
                                    record.assigneeId,
                                    record.startLogDate,
                                    record.timelogs._id
                                )
                            }
                        />
                    </Tooltip>
                );
            },
        });
    }


    return <Table columns={columns} dataSource={flatData} rowKey={(r) => r.timelogs._id} pagination={false} bordered />;
};

export default WorkReportFlatTable;
